var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.478 3.935A6.846 6.846 0 0 0 9.973 3a6.821 6.821 0 0 0-3.5.935 6.942 6.942 0 0 0-2.538 2.538A6.821 6.821 0 0 0 3 9.973c0 1.265.312 2.432.935 3.5a6.942 6.942 0 0 0 2.538 2.538 6.821 6.821 0 0 0 3.5.936c1.362 0 2.603-.36 3.723-1.08l5.036 5.061a.3.3 0 0 0 .425 0l1.772-1.771a.3.3 0 0 0 0-.425l-5.063-5.036a6.739 6.739 0 0 0 1.08-3.723 6.821 6.821 0 0 0-.935-3.5 6.953 6.953 0 0 0-2.533-2.538zM11.78 14.26a4.61 4.61 0 0 1-1.807.363c-.63 0-1.23-.122-1.802-.368a4.684 4.684 0 0 1-1.485-.994 4.684 4.684 0 0 1-.994-1.484 4.528 4.528 0 0 1-.368-1.803c0-.63.123-1.23.368-1.802a4.684 4.684 0 0 1 .994-1.485c.418-.417.913-.749 1.485-.994a4.528 4.528 0 0 1 1.802-.368c.63 0 1.23.123 1.803.368a4.684 4.684 0 0 1 1.484.994c.418.418.75.913.994 1.485.246.572.368 1.173.368 1.802 0 .63-.122 1.23-.368 1.803a4.684 4.684 0 0 1-.994 1.484c-.417.418-.91.75-1.48.999z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4389e17aeec97d419c0eaa5ef7584091.svg";
export { ForwardRef as ReactComponent };